import { takeLatest, all, put, call, select } from 'redux-saga/effects';

import apis from '../apis/chat';

import {
  types,
  getTaggableSubtopicsSuccess,
  getTaggableSubtopicsFailed,
  tagSubtopicsSuccess,
  tagSubtopicsFailed,
} from '../redux/tagging';
import { getSelectedQuestionID } from '../redux/selectQuestion';

function* endSessionFlow() {
  const QID = yield select(getSelectedQuestionID);

  try {
    const { subtopics } = yield call(apis.getTaggableSubtopics, QID);
    yield put(getTaggableSubtopicsSuccess(subtopics));
  } catch (err) {
    yield put(getTaggableSubtopicsFailed(err));
  }
}

export function* tagSubtopicsFlow(action) {
  const QID = yield select(getSelectedQuestionID);
  const { subtopicIds } = action.payload;

  try {
    yield call(apis.updateTaggableSubtopics, {
      QID,
      subtopicIds,
    });
    yield call(endSessionFlow);
    yield put(tagSubtopicsSuccess());
  } catch (error) {
    yield put(tagSubtopicsFailed(error));
  }
}

export default function* () {
  yield all([
    takeLatest(types.GET_TAGGABLE_SUBTOPCIS, endSessionFlow),
    takeLatest(types.TAG_SUBTOPICS, tagSubtopicsFlow),
  ]);
}



// WEBPACK FOOTER //
// ./src/scenes/Chat/services/sagas/tagging.js